/* eslint-disable react/display-name */
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { MdClose, MdMenu } from 'react-icons/md';
import { IconContext } from 'react-icons';
import { Link, graphql, StaticQuery } from 'gatsby';
import onClickOutside from 'react-onclickoutside';
import Back from './BackButton';
import HoverPicture from './Hover';
import AnimatedLogo from '../images/Logo_Final_Animated_Small.gif';
// import { randomNumber } from '../utils/functions';

const HoverArea = styled.button`
  outline: none;
  background: transparent;
  display: block;
  position: absolute;
  left: 0;
  height: 100%;
  width: 3rem;
  border: none;
  opacity: 1;
  transition: background 1s;
  &:hover {
    background: black;
    cursor: pointer;
  }
  overflow: hidden;
`;

const MobileWrapper = styled.div`
  @media (min-width: ${props => props.theme.breakpoint.l}) {
    display: none;
  }
`;

const DesktopWrapper = styled.div`
  @media (max-width: ${props => props.theme.breakpoint.l}) {
    display: none;
  }
`;

const HamburgerIcon = styled.button`
  top: 0;
  right: 0;
  position: fixed;
  background-color: transparent;
  border: none;
  padding: 0;
  outline: none !important;
  @media (max-width: ${props => props.theme.breakpoint.l}) {
    padding: 1rem 1rem 1rem 0.5rem;
    // padding: 0;
    animation: slideRight 2s cubic-bezier(0.075, 0.82, 0.165, 1) forwards;
  }
  &:hover {
    cursor: pointer;
  }
`;

const MenuLabel = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  margin: auto;
  transform: rotate(90deg);
  outline: none;
`;

const MenuWrapper = styled.div`
  position: absolute;
  @media (max-width: ${props => props.theme.breakpoint.l}) {
    display: block;
    z-index: 99999;
    background-color: black;
    background: black;
    width: 100vw;
    height: 100%;
    transform: translate3d(0, ${props => (props.toggle ? 0 : -200)}vh, 0);
    transition: transform 0.5s ${props => props.theme.bezier};
  }

  @media (min-width: ${props => props.theme.breakpoint.l}) {
    display: block;
    position: fixed;
    z-index: 20;
    left: -15;
    top: 0;
    width: 15rem;
    height: 100%;
    transform: translate3d(${props => (props.toggle ? 0 : -15)}rem, 0, 0);
    transition: transform 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);
  }
`;

const Wrapper = styled.div`
  @media (max-width: ${props => props.theme.breakpoint.l}) {
    display: flex;
    position: absolute;
    height: 100vh;
    background-color: black;
    margin: auto 0;
    left: 0rem;
    width: 100vw;
  }

  @media (min-width: ${props => props.theme.breakpoint.l}) {
    display: flex;
    position: absolute;
    height: 100%;
    background-color: black;
    margin: auto 0;
    left: 0rem;
    width: 13rem;
  }
`;

const CloseIcon = styled.button`
  top: 0;
  right: 0;
  position: absolute;
  margin: 1.2rem 0.5rem 0 0;
  background-color: black;
  border: none;
  outline: none !important;
  @media (max-width: ${props => props.theme.breakpoint.l}) {
    margin-right: 0.5rem;
  }
  &:hover {
    cursor: pointer;
  }
`;

const ColumnWrapper = styled.div`
  align-items: center;
  margin: auto;
  display: flex;
  flex-direction: column;
  text-align: left;
  text-transform: capitalize;
  h1 {
    letter-spacing: 0rem;
    line-height: 4.5rem;
  }
  h3 {
    font-family: ${props => props.theme.fontFamily.body};
    margin-top: 2rem;
    font-size: 1.85rem;
    font-weight: 400;
  }
  @media (max-width: ${props => props.theme.breakpoint.m}) {
    h1 {
      line-height: 3rem;
    }
    h3 {
      font-size: 1.5rem;
    }
  }
  @media (max-width: ${props => props.theme.breakpoint.s}) {
    h1 {
      line-height: 2.5rem;
    }
    h3 {
      font-size: 1.3rem;
    }
  }
`;

const MenuItems = styled.div`
  margin: auto;
  margin-left: 0;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0;

  @media (max-width: ${props => props.theme.breakpoint.s}) {
    padding: 0.75rem 0;
  }
`;

const StyledLogo = styled.div`
  max-width: 9rem;
  @media (max-width: ${props => props.theme.breakpoint.l}) {
    margin: 0 auto;
    max-width: 8rem;
  }

  @media (max-width: ${props => props.theme.breakpoint.s}) {
    margin: 0 auto;
    max-width: 7rem;
  }

  @media (max-width: ${props => props.theme.breakpoint.xs}) {
    padding: 1rem 0;
    margin: 0 auto;
    max-width: 7rem;
  }
`;

const HomeLink = styled(Link)`
  margin-bottom: 2rem;
  @media (max-width: ${props => props.theme.breakpoint.xs}) {
    margin-bottom: 0rem;
  }
`;

const StyledMenuButton = styled.div`
  color: ${props => props.theme.colors.bg};
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 1.4px;
  background-color: white;
  width: fit-content;
  line-height: 1.25rem;
  padding: 0.2rem 1rem;
  outline: none !important;
  border: none;
  margin: 0.15rem 0;
  transition: transform 500ms cubic-bezier(0.39, 0.575, 0.565, 1);
  &:hover {
    cursor: pointer;
  }
`;

const StyledLink = styled(Link)`
  user-select: none;
  color: ${props => props.theme.colors.bg};
  font-weight: 700;
  letter-spacing: 1.6px;
  background-color: white;
  width: fit-content;
  line-height: 1.25rem;
  padding: 0 0.2rem;
  margin: 0.3rem 0;
  transition: transform 500ms cubic-bezier(0.39, 0.575, 0.565, 1);
  &:hover {
    color: ${props => props.theme.colors.text};
    background-color: black !important;
  }
  ${HoverArea}:hover & {
    color: ${props => props.theme.colors.text};
    background-color: black !important;
  }
`;

const ContactLink = styled(StyledLink)`
  // margin-top: 2rem;
  background-color: ${props => props.theme.colors.contact};
  margin-bottom: calc(10vh);

  @media (max-width: ${props => props.theme.breakpoint.xs}) {
    margin-top: 1rem;
    margin-bottom: calc(1vh);
  }

  &:hover {
    color: ${props => props.theme.colors.contact};
    background-color: black !important;
  }
`;

const Bar = styled.div`
  width: 100%;
  height: 3.5rem;
  display: flex;
  position: fixed;
  justify-content: space-between;
  top: 0;
  left: 0;
  margin: 0;
  opacity: 1;
  border: none;
  background: black;
  z-index: 100;
`;

const MenuLogo = styled.img`
  @media (min-width: ${props => props.theme.breakpoint.l}) {
    display: none;
  }
`;

const HeaderLink = styled(Link)`
  margin: auto;
  padding-top: 0.3rem;
  max-width: 5rem;
`;

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { toggleState: false };
  }

  toggle = () => {
    this.setState(prevState => ({
      toggleState: !prevState.toggleState,
    }));
  };

  handleClickOutside = () => {
    this.setState({ toggleState: false });
  };

  render() {
    const { toggleState } = this.state;
    const { data, isIndex } = this.props;
    return (
      <React.Fragment>
        <MenuWrapper toggle={toggleState}>
          <Wrapper>
            <CloseIcon onClick={this.toggle}>
              <IconContext.Provider value={{ color: 'white', size: '1.25rem' }}>
                <MdClose />
              </IconContext.Provider>
            </CloseIcon>
            <ColumnWrapper>
              <HomeLink to="/">
                <StyledLogo>
                  <HoverPicture
                    initial={data.monochromeLogo.childImageSharp.resize.src}
                    secondary={AnimatedLogo}
                    toggle={toggleState}
                    onClick={this.toggle}
                    alt="Kid Sister - Home"
                  />
                </StyledLogo>
              </HomeLink>
              <MenuItems>
                <Section>
                  <StyledLink
                    onClick={this.toggle}
                    to="/films"
                    activeStyle={{
                      outline: '.1rem solid white',
                      outlineOffset: '0.1rem',
                      margin: '0.4rem 0 0.4rem 0.2rem',
                      paddingLeft: '0.3rem',
                      backgroundColor: 'black',
                      color: 'white',
                    }}
                  >
                    FILMS
                  </StyledLink>
                  <StyledLink
                    onClick={this.toggle}
                    to="/commercials"
                    activeStyle={{
                      outline: '.1rem solid white',
                      outlineOffset: '0.1rem',
                      margin: '0.4rem 0 0.4rem 0.2rem',
                      paddingLeft: '0.3rem',
                      backgroundColor: 'black',
                      color: 'white',
                    }}
                  >
                    COMMERCIALS
                  </StyledLink>
                  <StyledLink
                    to="/music-videos"
                    onClick={this.toggle}
                    activeStyle={{
                      outline: '.1rem solid white',
                      outlineOffset: '0.1rem',
                      margin: '0.4rem 0 0.4rem 0.2rem',
                      paddingLeft: '0.3rem',
                      backgroundColor: 'black',
                      color: 'white',
                    }}
                  >
                    MUSIC VIDEOS
                  </StyledLink>
                  <StyledLink
                    to="/short-form"
                    onClick={this.toggle}
                    activeStyle={{
                      outline: '.1rem solid white',
                      outlineOffset: '0.1rem',
                      margin: '0.4rem 0 0.4rem 0.2rem',
                      paddingLeft: '0.3rem',
                      backgroundColor: 'black',
                      color: 'white',
                    }}
                  >
                    SHORT FORM
                  </StyledLink>
                </Section>
                <Section>
                  <ContactLink
                    to="/contact"
                    onClick={this.toggle}
                    activeStyle={{
                      outline: '.1rem solid #f2ed7f',
                      outlineOffset: '0.1rem',
                      margin: '0.4rem 0 0.4rem 0.2rem',
                      paddingLeft: '0.3rem',
                      backgroundColor: 'black',
                      color: '#f2ed7f',
                    }}
                  >
                    CONTACT
                  </ContactLink>
                </Section>
              </MenuItems>
            </ColumnWrapper>
          </Wrapper>
        </MenuWrapper>
        <MobileWrapper>
          <Bar>
            {isIndex ? '' : <Back />}
            {/* <HeaderLink to="/">
              <MenuLogo src={data.navBarLogo.childImageSharp.resize.src} alt="Kid Sister - Home" />
            </HeaderLink> */}
            <HamburgerIcon onClick={this.toggle}>
              <IconContext.Provider value={{ color: 'white', size: '1.25rem' }}>
                <MdMenu />
              </IconContext.Provider>
            </HamburgerIcon>
          </Bar>
        </MobileWrapper>
        <DesktopWrapper>
          <HoverArea onClick={this.toggle}>
            <MenuLabel>
              <StyledMenuButton>MENU</StyledMenuButton>
            </MenuLabel>
          </HoverArea>
        </DesktopWrapper>
      </React.Fragment>
    );
  }
}

const EnhancedMenu = onClickOutside(Menu);

export default props => (
  <StaticQuery
    query={graphql`
      query {
        monochromeLogo: file(relativePath: { eq: "Logo_Final_BW.png" }) {
          childImageSharp {
            resize(width: 400, height: 777, quality: 75) {
              src
            }
          }
        }
        navBarLogo: file(relativePath: { eq: "MenuLogo.png" }) {
          childImageSharp {
            resize(width: 250, quality: 75) {
              src
            }
          }
        }
      }
    `}
    render={data => <EnhancedMenu data={data} {...props} />}
  />
);

Menu.propTypes = {
  data: PropTypes.shape({
    monochromeLogo: PropTypes.shape({
      childImageSharp: PropTypes.object.isRequired,
    }),
    navBarLogo: PropTypes.shape({
      childImageSharp: PropTypes.object.isRequired,
    }),
  }).isRequired,
  isIndex: PropTypes.bool.isRequired,
};
